import { CustomerQuoteListPage, QuotePartsPage } from 'quotes/pages';
import { VendorQuoteListPage } from 'quotes/pages/VendorQuoteListPage';

import { customerQuoteListPath, quotePartsPath, vendorQuoteListPath } from './routePaths';

export const quoteParts = {
  path: quotePartsPath(),
  exact: true,
  isPrivate: true,
  element: <QuotePartsPage />,
};

export const customerQuotes = {
  path: customerQuoteListPath(),
  exact: true,
  isPrivate: true,
  element: <CustomerQuoteListPage />,
};

export const vendorQuotes = {
  path: vendorQuoteListPath(),
  exact: true,
  isPrivate: true,
  element: <VendorQuoteListPage />,
};
